module.exports = __webpack_public_path__ + "static/img/exposure-pc-4.e6bdcf32.png";